import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Layout from './Layout';
import { loginLoader, rootLoader } from './loaders';

import CashbackControlPage from 'pages/CashbackControl/CashbackControlPage';
import CreatePartial from 'pages/CreatePartial';
import Customer from 'pages/Customer';
import Home from 'pages/Home';
import Login from 'pages/Login';
import { NfseHome, NfseLoteDetail, NfseNovoLote } from 'pages/Nfse';
import NfseWrapper from 'pages/Nfse/NfseWrapper';
import Reseller from 'pages/Reseller';

const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />,
    loader: loginLoader,
  },
  {
    path: '/create-partial',
    element: <CreatePartial />,
    loader: rootLoader,
  },
  {
    path: '/',
    element: <Layout />,
    loader: rootLoader,
    children: [
      {
        path: '/',
        element: <Home />,
      },
      {
        path: '/customer/:document',
        element: <Customer />,
      },
      {
        path: '/cashbacks',
        element: <CashbackControlPage />,
      },
      {
        path: '/financeiro',
        element: <NfseWrapper />,
        children: [
          {
            path: '',
            element: <NfseHome />,
          },
          {
            path: 'novo-lote',
            element: <NfseNovoLote />,
          },
          {
            path: 'lote/:id',
            element: <NfseLoteDetail />,
          },
        ],
      },
      {
        path: '/revendedor',
        element: <Reseller />,
      },
    ],
  },
]);

const Router = () => <RouterProvider router={router} />;

export default Router;
